import { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import Swal from 'sweetalert2'
import {
  DocumentoType,
  IconPaths,
  ModalSize,
  showAlertLoading,
  showConfirmAlert,
  showError,
} from '../../../../../../../_metronic/helpers'
import { useQueryResponse } from '../../core/QueryResponseProvider'
import { RowActions, useModal, useToast } from '../../../../../../components'
import { getEmpresaClienteById, updateEmpresaCliente } from '../../core/_request'
import { EmpresasClienteModal } from '../../components/modal/EmpresasClienteModal'
import { ClienteDtoUpdate, ClienteList } from '../../core/_models'

type Props = {
  cliente: ClienteList
}

export const EmpresasActionsCell: FC<Props> = ({ cliente }) => {
  const { showModal } = useModal()
  const { showToast } = useToast()
  const { refetch } = useQueryResponse()
  const navigate = useNavigate()
  const nome = cliente.nome || 'Empregador ASO'

  const openEditModal = () => {
    showModal({
      title: 'Empregador ASO',
      content: <EmpresasClienteModal />,
      size: ModalSize.Medium,
      fetchers: {
        cliente: () => getEmpresaClienteById(cliente.id),
      },
    })
  }

  // As telas filhas precisam da instituição do empregador, que só vem no detalhe.
  const openCliente = (path: string) => {
    getEmpresaClienteById(cliente.id)
      .then((result) =>
        navigate(
          `/apps/empresasCliente/${path}?cliente=${cliente.id}&empresa=${result?.empresa?.id}`
        )
      )
      .catch(showError)
  }

  const setStatus = async (ativo: boolean) => {
    showAlertLoading()
    try {
      const tipo = cliente.tipoDocumento as DocumentoType
      const documento = cliente.documento

      const data: ClienteDtoUpdate = {
        tipo,
        ativo,
        ...(tipo === DocumentoType.Cpf && { cpf: documento }),
        ...(tipo === DocumentoType.Cnpj && { cnpj: documento }),
        ...(tipo === DocumentoType.Caepf && { caepf: documento }),
      }
      await updateEmpresaCliente(cliente.id, data)
      Swal.close()
      showToast({ variant: 'success', title: `${nome} foi ${ativo ? 'ativado' : 'inativado'}.` })
      refetch()
    } catch (error) {
      showError(error)
    }
  }

  // Inativar pede confirmação; ativar é reversível e não pede.
  const askInativar = async () => {
    const confirmed = await showConfirmAlert({
      title: 'Inativar empregador ASO?',
      text: `${nome} será inativado. O cadastro continua guardado, e você pode reativá-lo quando quiser.`,
      confirmButtonText: 'Inativar',
      cancelButtonText: 'Cancelar',
      danger: true,
    })
    if (confirmed) await setStatus(false)
  }

  return (
    <RowActions
      itemName={nome}
      primaryAction={{ label: 'Alterar', onClick: openEditModal, icon: IconPaths.Pen }}
      items={[
        { label: 'Coordenadores', onClick: () => openCliente('coordenadores') },
        { label: 'Setores', onClick: () => openCliente('setores') },
        { label: 'Cargos', onClick: () => openCliente('cargos') },
        { label: 'Riscos', onClick: () => openCliente('riscos') },
        { label: 'Exames', onClick: () => openCliente('exames') },
        cliente.ativo
          ? { label: 'Inativar', onClick: askInativar, danger: true, divider: true }
          : { label: 'Ativar', onClick: () => setStatus(true), divider: true },
      ]}
    />
  )
}
